
import Bus from "@/plugins/bus.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloading:false
    }
  },
  mounted(){
    Bus.$on("finishDownload", data=> {this.downloading=false;})
  },
  beforeDestroy(){
       // 取消监听
      Bus.$off("finishDownload")
    },
  methods: {
    handleDownload() {
      this.downloading=true;
      Bus.$emit("sendDownload");
    },
    
    handleSend() {
      this.$emit("handleSend");
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
